'use client';

import clsx from 'clsx';
import Image from 'next/image';
import { FC, useLayoutEffect, useRef } from 'react';

import ScheduleMeeting from '@/components/WebsiteProdPage/ScheduleMeeting';
import { WebsiteAuditFormDto } from '@/components/WebsiteProdPage/ScheduleMeeting/types';
import useDevice from '@/hooks/useDevice';
import { gsap } from '@/lib/gsap';

import css from './style.module.scss';

interface Props {
	websiteAuditFormData: WebsiteAuditFormDto;
}

const AnalyzeWebsiteSection: FC<Props> = ({ websiteAuditFormData }) => {
	const device = useDevice();
	const wrapperRef = useRef<HTMLDivElement>(null);

	useLayoutEffect(() => {
		const wrapper = wrapperRef.current;
		const circle = wrapper?.querySelector(`.${css.curvedText}`);

		if (!wrapper || !circle) return;

		const ctx = gsap.context(() => {
			gsap.timeline({
				scrollTrigger: {
					trigger: wrapper,
					start: 'top bottom',
					end: 'bottom+=100% top',
					scrub: true,
					onUpdate: ({ progress }) => {
						const scrollProgress = progress * 360;
						gsap.to(circle, {
							rotate: scrollProgress,
							ease: 'none',
							duration: 0
						});
					}
				}
			});
		}, wrapper);

		return () => {
			ctx.revert();
		};
	}, []);

	return (
		<section ref={wrapperRef} className={clsx('wrapper', css.wrapper)}>
			<ScheduleMeeting
				websiteAuditFormData={websiteAuditFormData}
				className={css.formSection}
				contentClassName={css.content}
				variant="website-form"
			/>

			<div className={css.curvedWrapper}>
				<div className={css.curvedContainer}>
					<div className={css.circle} />
				</div>

				<div className={css.curvedContainer}>
					<Image
						preload
						width={device === 'desktop' ? 1775 : 424}
						height={device === 'desktop' ? 1775 : 424}
						alt=""
						className={css.curvedText}
						src={
							device === 'desktop'
								? '/assets/images/circle-text-white.webp'
								: '/assets/images/circle-text-mobile.webp'
						}
					/>
				</div>
			</div>
		</section>
	);
};

export default AnalyzeWebsiteSection;
